/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

type WithText = {
	text: string;
};

const ErrorView: React.FunctionComponent<WithText> = (props: React.PropsWithChildren<WithText>): JSX.Element => {
	const { text } = props;
	return (
		<Grid item container justifyContent="center" alignItems="center">
			<Typography variant="h5">{text}</Typography>
		</Grid>
	);
};

export const NotFoundErrorView: React.FunctionComponent<unknown> = (): JSX.Element => (
	<ErrorView text="Diese Seite existiert nicht." />
);

export const PERMISSION_ERROR_URL = '/permission-error';

export const PermissionErrorView: React.FunctionComponent<unknown> = (): JSX.Element => (
	<ErrorView text="Für diese Aktion hast du keine ausreichende Berechtigung" />
);
